const lang = {
  contact: 'Kontakt',
  born: 'Geboren',
  bornIn: 'in',
  experience: 'Berufserfahrung',
  education: 'Schulbildung',
  skills: 'Qualifikationen',
  about: 'Über mich'
};
export default lang;



// WEBPACK FOOTER //
// ./src/lang/de.js